addEventListener("DOMContentLoaded", _=> document.querySelectorAll(".slider").forEach(slider => {
    let setFgColor = (elem, cssVar) => elem.style.setProperty("--col-fg", getComputedStyle(elem).getPropertyValue(cssVar));
    let breaker = parseInt(FN.getCSSVar(document.body, "--break-lg-end"));

    let camera = slider.querySelector(".camera");
    let film = camera.querySelector(".film");
    let frames = film.children.length;

    let index = 0;
    let left = slider.children[0];
    let right = slider.children[2];
    if(frames<4) {
        setFgColor(left, "--col-light");
        setFgColor(right, "--col-light");
        return;
    }

    right.onclick = _=> {
        let batch = 4;
        if(document.body.offsetWidth <= breaker) batch = 2;
        if(index>=frames-batch) return;
        let shift = frames - index - batch;
        if(shift>batch) shift = batch;
        else setFgColor(right, "--col-light");
        setFgColor(left, "--col-fg0");
        let delta = parseFloat(film.style.marginLeft) || 0;
        film.style.marginLeft = delta - shift * (camera.offsetWidth/batch) + "px";
        index+= shift;
    }

    left.onclick = _=> {
        let batch = 4;
        if(document.body.offsetWidth <= breaker) batch = 2;
        if(index==0) return;
        let shift = index;
        if(shift>batch) shift = batch;
        else setFgColor(left, "--col-light");
        setFgColor(right, "--col-fg0");
        let delta = parseFloat(film.style.marginLeft) || 0;
        film.style.marginLeft = delta + shift * (camera.offsetWidth/batch) + "px";
        index-= shift;
    }
}));